import { AwsExports, EndpointConfig } from './endpoints-config.model';

class ImportError extends Error {}

const importGeneratedModules = async (): Promise<[AwsExports, EndpointConfig]> => {
  let awsExports;
  try {
    awsExports = await import('aws-exports');
  } catch (e) {
    throw new ImportError(
      'Unable to import module \'frontend/src/aws-exports.js\' - You need to run terraform at least once before starting the site',
    );
  }

  let endpointConfig;
  try {
    endpointConfig = await import('endpoint-config');
  } catch (e) {
    throw new ImportError(
      'Unable to import module \'frontend/src/endpoint-config.ts\' - You need to create this file manually (see frontend/README.md)',
    );
  }

  return [
    awsExports.default as unknown as AwsExports,
    endpointConfig.default as unknown as EndpointConfig,
  ];
};

export const loadApiEndpoint = async () => {
  const [awsExports, endpointConfig] = await importGeneratedModules();
  return endpointConfig.server === 'local' ? awsExports.staff_api_gw_local : awsExports.staff_api_gw_aws;
};

export const loadSiteUrl = async () => {
  const [awsExports, endpointConfig] = await importGeneratedModules();
  return endpointConfig.site === 'local' ? awsExports.site_url_local : awsExports.site_url_aws;
};

export const loadAmplifyConfig = async () => {
  const [awsExports, endpointConfig] = await importGeneratedModules();
  return {
    ...awsExports,
    oauth: endpointConfig.site === 'local' ? awsExports.oauth_local : awsExports.oauth_aws,
    // AppSync config — lets Amplify.API.graphql speak AppSync's subscription protocol
    aws_appsync_graphqlEndpoint: awsExports.appsync_uri,
    aws_appsync_region: awsExports.aws_cognito_region,
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  };
};

export const loadAppSyncUri = async () => {
  const [awsExports] = await importGeneratedModules();
  return awsExports.appsync_uri;
};

export const loadAppSyncWssUri = async () => {
  const [awsExports] = await importGeneratedModules();
  return awsExports.appsync_wss_uri;
};
